export default "__VITE_ASSET__82cec098__"